import { LinearProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Loader = () => {
  const theme = useTheme();

  return (
    <LinearProgress
      color="secondary"
      sx={{
        height: 3,
        '& .MuiLinearProgress-bar': {
          backgroundColor: theme.palette.primary.main,
        },
      }}
    />
  );
};

export default Loader;
